import { buildDealflowApiUrl } from "../DealFlow/dealflowRuntimeConfig";

const DEALFLOW_SUBSCRIPTION_URL = buildDealflowApiUrl("/rfdb/pp/edge/createSubscription");
const DEALFLOW_PREPARE_SUBSCRIPTION_PAYMENT_URL = buildDealflowApiUrl(
  "/rfdb/pp/edge/prepareSubscriptionPayment"
);
const DEALFLOW_CONFIRM_SUBSCRIPTION_PAYMENT_URL = buildDealflowApiUrl(
  "/rfdb/pp/edge/confirmSubscriptionPayment"
);

function getApiErrorMessage(data, fallback) {
  return data?.error || data?.details || data?.message || fallback;
}

/**
 * @typedef {Object} CreateDealflowSubscriptionRequest
 * @property {string} license_key
 * @property {string} idempotency_key
 */

/**
 * @param {CreateDealflowSubscriptionRequest} params
 */
export async function createDealflowSubscription({
  license_key,
  idempotency_key,
}) {
  if (!license_key) {
    throw new Error("Missing required field: license_key");
  }
  if (!idempotency_key) {
    throw new Error("Missing required field: idempotency_key");
  }

  const response = await fetch(DEALFLOW_SUBSCRIPTION_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      license_key,
      idempotency_key,
    }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  if (!response.ok) {
    throw new Error(getApiErrorMessage(data, "Failed to create subscription."));
  }

  if (!data?.subscription_id) {
    throw new Error("Subscription created but subscription_id was missing.");
  }
  if (!data?.purchase_reference_id) {
    throw new Error("Subscription created but purchase_reference_id was missing.");
  }

  console.log("[DealFlow API] createSubscription response", data);

  return data;
}

export async function prepareDealflowSubscriptionPayment({
  subscription_id,
  purchase_reference,
  license_key,
  idempotency_key,
  email,
  billing_address,
  first_name,
  last_name,
  company,
}) {
  console.log("[DealFlow API] prepareSubscriptionPayment request", {
    subscription_id,
    purchase_reference,
    license_key,
    idempotency_key,
    email,
    billing_address,
    first_name,
    last_name,
    company,
    url: DEALFLOW_PREPARE_SUBSCRIPTION_PAYMENT_URL,
  });

  const response = await fetch(DEALFLOW_PREPARE_SUBSCRIPTION_PAYMENT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      subscription_id,
      purchase_reference,
      license_key,
      idempotency_key,
      email,
      billing_address,
      first_name,
      last_name,
      company,
    }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  console.log("[DealFlow API] prepareSubscriptionPayment response", {
    ok: response.ok,
    status: response.status,
    data,
  });

  if (!response.ok) {
    throw new Error(getApiErrorMessage(data, "Failed to prepare subscription payment."));
  }

  if (!data?.ok) {
    throw new Error(getApiErrorMessage(data, "Prepare subscription payment step failed."));
  }

  return data;
}

export async function confirmDealflowSubscriptionPayment({ subscription_id }) {
  console.log("[DealFlow API] confirmSubscriptionPayment request", {
    subscription_id,
    url: DEALFLOW_CONFIRM_SUBSCRIPTION_PAYMENT_URL,
  });

  const response = await fetch(DEALFLOW_CONFIRM_SUBSCRIPTION_PAYMENT_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ subscription_id }),
  });

  let data = null;
  try {
    data = await response.json();
  } catch {
    data = null;
  }

  console.log("[DealFlow API] confirmSubscriptionPayment response", {
    ok: response.ok,
    status: response.status,
    data,
  });

  if (!response.ok) {
    throw new Error(getApiErrorMessage(data, "Failed to confirm subscription payment."));
  }

  if (!data?.ok) {
    throw new Error(getApiErrorMessage(data, "Confirm subscription payment step failed."));
  }

  return data;
}
